import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { StoreStore } from "./types";

const useStore = create<StoreStore>()(
    persist(
        (set) => ({
            storeId: null,
            store: null,
            setStore: (storeId, store) => set({ storeId, store }),
            clearStore: () => set({ storeId: null, store: null }),
        }),
        { name: "store", partialize: (state) => ({ storeId: state.storeId, store: state.store }) }
    )
);

export default useStore;
